import { LOCAL_SESSION, LOCAL_SESSION_TIME } from './common/name-space';

type storageProps = {
  key: string;
  value: object;
  expire?: string;
};
export const setStorage = ({ ...payload }: storageProps) => {
  const { key, value } = payload;
  if (!value) {
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getStorage = (key: string): string | null => {
  return sessionStorage.getItem(key || '{}');
};

export const deleteStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
export const localSetStorage = ({ ...payload }: storageProps) => {
  const { key, value } = payload;
  if (!value) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const baseLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};
export const localGetStorage = (key: string) => {
  const re = localStorage.getItem(key);
  if (!re) {
    return null;
  }
  return JSON.parse(re);
};

export const localDeleteStorage = (key: string) => {
  localStorage.removeItem(key);
};
type localReturnProps = {
  auth: string;
  point: string;
};

export const authLocalStorage = (): localReturnProps => {
  const re = localGetStorage('auth');
  if (!re) {
    return {
      auth: '',
      point: '',
    };
  }
  return re;
};

type urlSessionStorageProps = {
  url: string;
};
export const urlSessionStorage = (): urlSessionStorageProps => {
  const re = getStorage('url');
  if (!re) {
    return { url: '/signIn' };
  }
  return JSON.parse(re);
};

export const langSessionStorage = () => {
  const re = getStorage('lang');
  if (!re) {
    return {
      lang: 'en',
    };
  }
  return JSON.parse(re);
};

export type loginStorageProps = {
  key: 'login';
  value: {
    email: string;
    keep: boolean;
    auth: string;
    sns?: string;
  };
};
export type resLoginStorageProps = {
  email: string;
  keep: boolean;
  auth: string; // bio, pin, email, oauth
  sns?: string; // naver, google
};
const initLoginStorage = () => {
  return {
    email: '',
    keep: false,
    auth: '',
    sns: '',
  };
};
export const loginLocalStorage = (): resLoginStorageProps => {
  const re: resLoginStorageProps | null = localGetStorage('login');
  if (!re) {
    return {
      ...initLoginStorage(),
    };
  }
  return re;
};

export const bioLocalStorage = () => {
  const re = localGetStorage('bio_check');
  if (!re) {
    return null;
  }
  return re;
};

export const setBioLocalStorage = (key: string, value: number) => {
  if (!key && !value) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const setSession = () => {
  const now = new Date();
  const payload = {
    key: LOCAL_SESSION,
    value: {
      sessionTime: now.getTime() + LOCAL_SESSION_TIME,
    },
  };
  localSetStorage(payload);
};

// export const changeLoginType = async (web3authCall: Web3AuthCall) => {
//   const res = localGetStorage('snsAddress');
//   if (!res) {
//     return;
//   }
//   const re = await web3authCall!.getUserInfo();
//   const loginType = re.typeOfLogin ?? 'external';
//   const payload = {
//     key: 'snsAddress',
//     value: {
//       ...res,
//       typeOfLogin: loginType,
//     },
//   };
//   localSetStorage(payload);
// };

// 스토리지에 배열로 저장
export const LocalSetStorageArr = (key: string, array: any[]) => {
  const jsonString = JSON.stringify(array); // 배열을 JSON 문자열로 변환
  localStorage.setItem(key, jsonString); // JSON 문자열로 sessionStorage에 저장
};

// 배열에 요소 추가 후 다시 저장 (이전 배열이 있으면 추가)
export const addLocalSetStorageArr = (key: string, newElement: any) => {
  let array = localGetStorage(key); // 기존 배열 가져오기

  if (!array) {
    array = []; // 배열이 없으면 새로운 배열 생성
  }

  array.push(newElement); // 새로운 요소 추가
  LocalSetStorageArr(key, array); // 배열을 다시 저장
};

export const removeFirstLocalStorage = (key: string) => {
  let array = localGetStorage(key); // 기존 배열 가져오기

  if (array && array.length > 0) {
    array.shift(); // 배열의 첫 번째 요소 삭제
    LocalSetStorageArr(key, array); // 배열을 다시 저장
  }
};
